import { Button } from "@workspace/ui/components/button";
import { cn } from "@workspace/ui/lib/utils";
import { HelpCircle, MenuIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { DashboardMobileMenu } from "@/components/dashboard-sidebar";
import { SubmitFeedbackModal } from "@/components/modals/misc/submit-feedback";
import { NotificationCenter } from "@/components/notifications/notification-center";
import { UserAvatarMenu } from "@/components/user-avatar-menu";

type DashboardHeaderProps = {
  hideOnMobile?: boolean;
};

export function DashboardHeader({
  hideOnMobile = false,
}: DashboardHeaderProps) {
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <>
      <header
        className={cn(
          "relative z-40 flex h-[70px] shrink-0 items-center border-b bg-background px-4 md:px-6",
          hideOnMobile && "hidden md:flex"
        )}
      >
        <DashboardMobileMenu>
          <MenuIcon className="size-4" />
        </DashboardMobileMenu>
        <div className="ml-auto flex items-center gap-2">
          <Button
            asChild
            className="text-muted-foreground"
            size="icon"
            variant="ghost"
          >
            <Link href="/support">
              <HelpCircle className="size-4" />
              <span className="sr-only">Support</span>
            </Link>
          </Button>
          <NotificationCenter />
          <UserAvatarMenu
            align="end"
            avatarSize="md"
            compact
            onFeedbackSelect={() => setFeedbackOpen(true)}
            showOrganizations={false}
            side="bottom"
          />
        </div>
      </header>

      <SubmitFeedbackModal
        isOpen={isFeedbackOpen}
        onOpenChange={setFeedbackOpen}
      />
    </>
  );
}
